module.exports = __webpack_public_path__ + "static/media/BattleOfBrooklyn.7d4f3f90.svg";